const createObserver = (el, binding) => {
  const options = binding?.value || {}
  const animationClass = options.class || 'animate-fade-up'
  const delay = options.delay || 0

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.style.opacity = '1'
          el.style.animationDelay = `${delay}s`
          el.classList.add(animationClass)
          obs.unobserve(entry.target)
        }
      })
    },
    {
      threshold: options.threshold || 0.2
    }
  )

  el.style.opacity = '0'
  observer.observe(el)
  el.__scrollRevealObserver = observer
}

export default {
  mounted(el, binding) {
    createObserver(el, binding)
  },
  updated(el, binding) {
    if (el.__scrollRevealObserver) {
      el.__scrollRevealObserver.disconnect()
    }
    createObserver(el, binding)
  },
  unmounted(el) {
    if (el.__scrollRevealObserver) {
      el.__scrollRevealObserver.disconnect()
      delete el.__scrollRevealObserver
    }
  }
}

